import { get, post, put } from './api';
import {
  GetUserProfileResponseDTO,
  UpdateUserRequestBodyDTO,
  UploadUserColumnPreferences,
} from 'declarations/dto/user';

export const getUserProfile = async () => {
  const response = await get<GetUserProfileResponseDTO>(`/users/profile`);

  return response.data;
};

export const putUserProfile = async (userProfileData: UpdateUserRequestBodyDTO) => {
  const response = await put<void>(`/users/${userProfileData.get('UserId')}`, userProfileData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const getUserColumnPreferences = async () => {
  const response = await get<string>(`/users/column-preferences`);

  return response.data;
};

export const uploadUserColumnPreferences = async (data: UploadUserColumnPreferences) => {
  const response = await post<void>(`/users/column-preferences`, data);

  return response.data;
};
